import { CustomformsService } from './../../apiclient/api/customforms.service';
import { UserSessionService } from './../../UserSession/user-session.service';

import { Component, Input, OnInit, TemplateRef, OnDestroy } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { NbDialogService } from '@nebular/theme';
import { CompanyService, UserService } from '../../apiclient';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

/**
 * Componente que renderiza la columna de Acciones del listado de customforms
 */
@Component({
  templateUrl: './customforms.actions.cell.component.html',
})
export class CustomformsActionsCellComponent implements ViewCell, OnInit, OnDestroy {
  mySubscription: any;
  renderValue: string;
  customformid: string;
  companyid: string;
  @Input() value: string | number;
  @Input() rowData: any;

  /**
   * @ignore
   */
  ngOnInit() {

    this.renderValue = this.value.toString().toUpperCase();
    this.customformid = this.rowData.id;
    this.companyid = this.rowData.company_id;

  }

  constructor(private dialogService: NbDialogService,private userSessionService : UserSessionService,
     private customformsService: CustomformsService,private router: Router) {
      this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
      };

      this.mySubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // Trick the Router into believing it's last link wasn't previously loaded
          this.router.navigated = false;
        }
      });
  }

  /**
   * Eliminar customform
   * @param dialog Diálogo de confirmación
   * @param customformid Id del customform a eliminar
   */
  deleteCustomform(dialog: TemplateRef<any>, customformid): void {
    console.log("Queremos borrar el customform "+customformid);
    this.dialogService.open(dialog,{context:customformid});
  }

  /**
   * Confirma la eliminación de un customform
   * @param customformid Id del customform
   */
  confirmarEliminar(customformid): void {
    console.log("Confirmamos que Queremos borrar el customform "+customformid);

    this.customformsService.deletecustomform(customformid,this.userSessionService.accessToken).subscribe((data) => {
        this.router.navigate(['pages/customforms',{'refresh':(new Date).getTime()}]);
    })


  }

  /**
   * @ignore
   */
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

}
